const ptTranslation = () => {
    return {
        common: {
            edit: 'Editar',
            create: 'Criar',
            save: 'Salvar',
            update: 'Atualizar',
            saving: 'Salvando...',
            cancel: 'Cancelar',
            delete: 'Excluir',
            search: 'Pesquisar',
            title: 'Título',
            description: 'Descrição',
            intensity: 'Intensidade',
            areYouSure: 'Tem certeza?',
            none: 'Nenhum',
            all: 'Todos',
            sessionExpired: 'Sua sessão expirou',
            errorOccurred: 'Ocorreu um erro',
            success: 'Sucesso',
            error: 'Erro',
            warning: 'Aviso',
            info: 'Informação',
            confirm: 'Confirmar',
            back: 'Voltar',
            next: 'Próximo',
            previous: 'Anterior',
            loading: 'Carregando...',
            noData: 'Nenhum dado disponível',
            actions: 'Ações',
            close: 'Fechar',
            submit: 'Enviar',
            reset: 'Redefinir',
            requiredField: 'Este campo é obrigatório',
            invalidEmail: 'E-mail inválido',
            invalidPhone: 'Número de telefone inválido',
            invalidUrl: 'URL inválida',
            invalidDate: 'Data inválida',
            invalidTime: 'Hora inválida',
            invalidDatetime: 'Data e hora inválidas',
            invalidNumber: 'Número inválido',
            invalidInteger: 'Número inteiro inválido',
            invalidDecimal: 'Número decimal inválido',
            invalidPassword: 'Senha inválida',
            invalidConfirmPassword: 'As senhas não conferem',
            invalidMinLength: 'Deve ter pelo menos {min} caracteres',
            invalidMaxLength: 'Não deve exceder {max} caracteres',
            active: 'Ativo',
            yes: 'Sim',
            no: 'Não',
            status: 'Status',
            showCompleted: 'Mostrar concluídos',
            completed: 'Concluído',
            created: 'Criado em',
            copy: 'Copiar',
            copied: 'Copiado',
            filters: 'Filtros',
            noResults: 'Nenhum resultado',
        },
        filter: {
            search: {
                placeholder: 'Pesquisar...',
            },
            category: {
                label: 'Categoria',
                all: 'Todas as categorias',
            },
            sort: {
                label: 'Ordenar por',
                default: 'Padrão',
            },
            resultsCount: '{{count}} resultado(s) encontrado(s)',
        },
        faq: {
            title: 'Perguntas Frequentes',
            noFaq: 'Nenhuma pergunta frequente disponível no momento.',
            deleteSuccess: 'A pergunta foi excluída com sucesso',
            deleteError: 'Ocorreu um erro ao excluir a pergunta',
            updateSuccess: 'A pergunta foi atualizada com sucesso',
            manage: 'Gerenciamento de Perguntas Frequentes',
            edit: 'Editar pergunta',
            create: 'Criar pergunta',
            createSuccess: 'Pergunta criada com sucesso',
            categories: {
                all: 'Todas as categorias',
                general: 'Geral',
                account: 'Conta',
                subscription: 'Assinatura',
                payment: 'Pagamento',
                other: 'Outro',
            },
            form: {
                question: 'Pergunta',
                answer: 'Resposta',
                category: 'Categoria',
                order: 'Ordem de exibição',
                isActive: 'Ativo',
                newQuestion: 'Nova pergunta',
                editQuestion: 'Editar pergunta',
                createSuccess: 'Pergunta criada com sucesso',
                updateSuccess: 'Pergunta atualizada com sucesso',
                deleteSuccess: 'Pergunta excluída com sucesso',
                deleteConfirm: 'Tem certeza de que deseja excluir esta pergunta?',
                validation: {
                    questionRequired: 'A pergunta é obrigatória',
                    answerRequired: 'A resposta é obrigatória',
                    categoryRequired: 'A categoria é obrigatória',
                },
            },
            filter: {
                category: 'Filtrar por categoria',
                showInactive: 'Mostrar perguntas inativas',
                markAsComplete: 'Marcar como concluído',
                markAsIncomplete: 'Marcar como não concluído',
                inactive: 'Inativo',
                lastUpdated: 'Última atualização',
                completed: 'Concluído',
            },
            invalidMinValue: 'Deve ser maior ou igual a {min}',
            invalidMaxValue: 'Deve ser menor ou igual a {max}',
            invalidPattern: 'Formato inválido',
            invalidRequired: 'Este campo é obrigatório',
            invalidUrlFormat: 'Formato de URL inválido',
            invalidEmailFormat: 'Formato de e-mail inválido',
            invalidPhoneFormat: 'Formato de telefone inválido',
            invalidDateRange: 'A data final deve ser posterior à data inicial',
            invalidTimeRange: 'A hora final deve ser posterior à hora inicial',
            invalidDatetimeRange: 'A data e hora finais devem ser posteriores à data e hora iniciais',
        },
        global: {
            monday: 'Segunda-feira',
            tuesday: 'Terça-feira',
            wednesday: 'Quarta-feira',
            thursday: 'Quinta-feira',
            friday: 'Sexta-feira',
            saturday: 'Sábado',
            sunday: 'Domingo',
            lang: {
                fr: 'Francês (French)',
                gb: 'Inglês (English)',
                br: 'Brasil (Brazil)',
            },
            back: 'Voltar',
        },
        home: {
            'main-title': "Badminton Villeneuve d'Ascq",
            'presentation-1': 'Jovens e Adultos, competidores e lazer, ',
            'presentation-2': ' ',
            'presentation-3': '',
            'presentation-4': ' O BVA promove a diversão para todos os jogadores de badminton.',
            'last-news': 'Últimas notícias',
        },
        header: {
            menu: {
                home: 'Início',
                planning: 'Planos e Preços',
                registration: 'Inscrever-se',
                badnetTournaments: 'Calendário de Competições',
                contact: 'Fale conosco',
                faq: 'Perguntas Frequentes',
                'my-space-bva': 'Meu espaço BVA',
                login: 'Entre',
                'forgot-password': 'Esqueceu a senha?',
                'reset-password': 'Redefinir senha',
                'send-email': 'Enviar',
                'pseudo-received-by-email': 'Nome de usuário * (recebido por email)',
                'enter-email-or-pseudo': 'Digite seu email ou nome de usuário',
                'enter-password': 'Digite sua senha',
                email: 'Endereço de email',
                'email-placeholder': 'Digite seu endereço de email',
                'pseudo-placeholder': 'Digite seu nome de usuário',
                'reset-password-email-sent': 'Um email de redefinição foi enviado',
                member: 'Membro',
                coach: 'Treinador',
                admin: 'Administrador',
                connexion: 'Conexão',
                'account-type': 'Tipo de conta',
                'select-account-type': 'Selecione um tipo de conta',
            },
            login: {
                connexion: 'Conexão',
                member: 'Membro',
                coach: 'Treinador',
                admin: 'Administrador',
                'account-type': 'Tipo de conta',
                'select-account-type': 'Selecione um tipo de conta',
                'connection-success': 'Conexão bem-sucedida',
                'go-to-member-space': 'Ir para o espaço do membro',
                'go-to-coach-space': 'Ir para o espaço do treinador',
                'go-to-admin-space': 'Ir para o espaço do administrador',
                'forgot-password': 'Esqueceu a senha?',
                'reset-password': 'Redefinir senha',
                'reset-password-email-sent': 'Um email de redefinição foi enviado',
                'send-email': 'Enviar',
                pseudo: 'Nome de usuário',
                'enter-pseudo': 'Digite seu nome de usuário',
                'pseudo-placeholder': 'Seu nome de usuário',
                'pseudo-received-by-email': 'Nome de usuário * (recebido por email)',
                'enter-email-or-pseudo': 'Digite seu email ou nome de usuário',
                'enter-password': 'Digite sua senha',
                email: 'Endereço de email',
                'email-placeholder': 'Digite seu endereço de email',
                password: 'Senha',
                'email-label': 'Email',
                'email-or-pseudo': 'Email ou nome de usuário',
                'enter-email': 'Digite seu email',
                connect: 'Conectar',
            },
            'my-tournament-account': 'Minha conta de torneios',
            'tournament-account-message':
                'A conta de torneios começa em 0€ e pode alcançar o máximo de 25€.Ela diz respeito somente aos competidores. É fácil para aumentar os valores na sua conta: basta participar dos treinamentos e nos avisar se estiver ausente.',
        },
        footer: {
            copyright: `Copyright © ${new Date().getFullYear()}. Todos os direitos reservados - Site criado por`,
            administration: 'Administrador',
        },
        sidebar: {
            admin: {
                dashboard: 'Painel',
                user: 'Usuário',
                news: 'Notícias',
                partners: 'Parceiros',
                badnet: 'Calendário de Competições',
                plannings: 'Planos',
                prices: 'Taxas',
                documentation: 'Documentação',
                'bva-bot': 'BVA bot',
                'to-document-myself': 'Para me documentar',
                coachs: 'Coachs',
                carousel: 'Carrossel',
                faq: 'Perguntas Frequentes',
                'training-sessions': 'Sessões de Treinamento',
                trainingSessions: {
                    title: 'Minhas Sessões de Treinamento',
                    filterByIntensity: 'Filtrar por intensidade',
                    noSessions: 'Nenhuma sessão encontrada',
                    steps: 'Etapas',
                    startTime: 'Hora de início',
                    endTime: 'Hora de término',
                    createdSuccess: 'A sessão foi criada com sucesso',
                    updatedSuccess: 'A sessão foi atualizada com sucesso',
                    exercise: 'Exercício',
                    addStep: 'Adicionar etapa',
                    deleteSuccess: 'Sessão excluída com sucesso',
                    deleteError: 'Ocorreu um erro ao excluir a sessão',
                    createSuccess: 'Sessão criada com sucesso',
                    createError: 'Ocorreu um erro ao criar a sessão',
                    updateSuccess: 'Sessão atualizada com sucesso',
                    updateError: 'Ocorreu um erro ao atualizar a sessão',
                    toggleCompleteSuccess: 'Status da sessão atualizado com sucesso',
                    toggleCompleteError: 'Ocorreu um erro ao atualizar o status da sessão',
                    session: 'sessão',
                    newSession: 'Nova Sessão',
                    editSession: 'Editar Sessão',
                    viewMembers: 'Ver membros',
                    groupMembers: 'Membros do grupo',
                    sessionTitle: 'Título',
                    sessionDescription: 'Descrição',
                    sessionIntensity: 'Intensidade',
                    sessionIntensityLow: 'Baixa',
                    sessionIntensityMedium: 'Média',
                    intensityHigh: 'Alta',
                    intensityVeryHigh: 'Muito alta',
                    intensityExtreme: 'Extrema',
                    group: 'Grupo',
                    noGroup: 'Nenhum grupo',
                    groupPlaceholder: 'Selecione um grupo',
                    groupHelp: 'Opcional - Associe esta sessão a um grupo existente',
                    sessionDescriptionPlaceholder: 'Descreva o conteúdo da sessão...',
                    sessionTitlePlaceholder: 'Digite o título da sessão',
                    sessionSteps: 'Etapas da Sessão',
                    stepTitle: 'Título',
                    stepStartTime: 'Hora de início',
                    stepEndTime: 'Hora de término',
                    stepExercise: 'Exercício Associado (opcional)',
                    stepDescription: 'Descrição (opcional)',
                    noExercise: 'Nenhum exercício',
                    addStepButton: 'Adicionar uma etapa',
                    deleteStep: 'Excluir esta etapa',
                    step: 'Etapa',
                    stepNumber: 'Etapa {{number}}',
                    moveUp: 'Mover para cima',
                    moveDown: 'Mover para baixo',
                    viewExercise: 'Ver detalhes do exercício',
                    generateExercise: 'Gerar exercício',
                    loading: '...',
                    errors: {
                        titleRequired: 'O título é obrigatório',
                        stepTitleRequired: 'O título da etapa {{index}} é obrigatório',
                        invalidTimeRange: 'A hora de término deve ser posterior à hora de início (etapa {{index}})',
                        overlappingSteps: 'As etapas {{step1}} e {{step2}} se sobrepõem',
                        authRequired: 'Autenticação necessária',
                        genericError: 'Ocorreu um erro',
                        errorOccurred: 'Ocorreu um erro',
                        sessionRequired: 'Sessão necessária',
                    },
                },
            },
            member: {
                'my-progression': 'Minha progressão',
                password: 'Senha',
                'satisfaction-survey': 'Pesquisa de Satisfação',
                'satisfaction-survey-thank-you':
                    'Obrigado por dedicar tempo para compartilhar sua experiência conosco.',
                'satisfaction-survey-iframe-fallback':
                    'A pesquisa de satisfação não pode ser exibida. Por favor, clique neste link para acessá-la.',
            },
        },
        admin: {
            dashboard: 'Painel',
            or: 'ou',
            'search-member-input': '🔍 Pesquisar um membro',
            'search-coach-input': '🔍 Pesquisar um coach',
            'users-title': 'Usuários',
            carousel: {
                title: 'Carrossel',
                addImage: 'Adicionar imagem',
                settings: 'Configurações',
                interval: 'Intervalo (segundos)',
                transition: 'Transição',
                transitionFade: 'Desvanecer',
                transitionSlide: 'Deslizar',
                delete: 'Excluir',
                active: 'Ativo',
                inactive: 'Inativo',
                order: 'Ordem',
                noImages: 'Nenhuma imagem disponível',
                addImageSuccess: 'Imagem adicionada com sucesso',
                deleteImageSuccess: 'Imagem excluída com sucesso',
                updateSettingsSuccess: 'Configurações atualizadas com sucesso',
                updateOrderSuccess: 'Ordem atualizada com sucesso',
                toggleActiveSuccess: 'Status atualizado com sucesso',
            },
            badnet: {
                'sync-button': 'Sincronizar BadNet',
                syncing: 'Sincronizando...',
                'sync-success': 'Sincronização bem-sucedida!',
                'sync-error': 'Erro de sincronização',
                'tournaments-synced': 'torneios sincronizados',
                'tournaments-success': 'bem-sucedidos',
                'tournaments-failed': 'falharam',
                title: 'Calendário de Competições',
                'delete-old': 'Excluir torneios antigos',
                total: 'Total',
                upcoming: 'Em breve',
                past: 'Passados',
            },
        },
        coach: {
            dashboard: 'Painel',
            'my-members': 'Meus membros',
            'my-sessions': 'Minhas sessões',
            'members-added': 'Membros adicionados',
            'members-removed': 'Membros removidos',
            skills: 'Habilidades',
            'skill-already-exist': 'Habilidade já existente',
            'add-skill': 'Adicionar habilidade',
            'skill-edited': 'Habilidade editada',
            'skill-deleted': 'Habilidade deletada',
            '4-players-with-most-missings': '4 jogadores com mais faltas',
            'skills-least-mastered': 'Habilidades menos dominadas',
            noGroupsWithMembers: 'Nenhum grupo com membros encontrado',
            noPlayersWithMissings: 'Nenhum jogador com faltas neste grupo',
            noSkillsToDisplay: 'Nenhuma habilidade para exibir para este grupo',
            trainingSessionGroups: {
                title: 'Grupos de Sessões de Treino',
                createTitle: 'Criar Grupo',
                editTitle: 'Editar Grupo',
                members: 'Membros',
                deleteSuccess: 'Grupo excluído com sucesso',
                deleteError: 'Ocorreu um erro ao excluir o grupo',
                createSuccess: 'Grupo criado com sucesso',
                createError: 'Ocorreu um erro ao criar o grupo',
                updateSuccess: 'Grupo atualizado com sucesso',
                updateError: 'Ocorreu um erro ao atualizar o grupo',
                form: {
                    title: 'Título',
                    description: 'Descrição',
                },
                filters: {
                    search: 'Pesquisar',
                    searchPlaceholder: 'Pesquisar um grupo...',
                },
                shareWithCoaches: 'Compartilhar com treinadores',
                shareWithCoachesHelp: 'Selecione os treinadores com quem compartilhar este grupo de sessões',
            },
            exercises: {
                title: 'Exercícios',
                addExercise: 'Adicionar um exercício',
                searchPlaceholder: 'Pesquisar um exercício...',
                filters: {
                    intensity: 'Intensidade',
                    gameType: 'Tipo de jogo',
                    courtType: 'Tipo de quadra',
                    peopleCount: 'Número de pessoas',
                    skills: 'Habilidades',
                    all: 'Todas',
                    gameTypeSingles: 'Simples',
                    gameTypeDoubles: 'Duplas',
                    gameTypeBoth: 'Ambos',
                    courtTypeFull: 'Completa',
                    courtTypeHalf: 'Meia quadra',
                    courtTypeBoth: 'Ambos',
                },
                exerciseItem: {
                    people: 'pessoa',
                    courtTypeEnum: {
                        FULL: 'Completo',
                        HALF: 'Meia quadra',
                        BOTH: 'Ambos',
                    },
                },
                createSuccess: 'O exercício foi criado com sucesso',
                createError: 'Ocorreu um erro ao criar o exercício',
                updateSuccess: 'O exercício foi atualizado com sucesso',
                updateError: 'Ocorreu um erro ao atualizar o exercício',
                deleteSuccess: 'O exercício foi excluído com sucesso',
                deleteError: 'Ocorreu um erro ao excluir o exercício',
                deleting: 'Excluindo...',
                exercise: 'um exercício',
                description: 'Descrição',
                peopleCount: 'Número de pessoas',
                intensity: 'Intensidade',
                intensityLow: 'Baixa',
                intensityMedium: 'Média',
                intensityHigh: 'Alta',
                gameType: 'Tipo de jogo',
                gameTypeSingles: 'Simples',
                gameTypeDoubles: 'Duplas',
                gameTypeBoth: 'Ambos',
                courtType: 'Tipo de quadra',
                courtTypeFull: 'Completa',
                courtTypeHalf: 'Meia quadra',
                courtTypeBoth: 'Ambos',
                skills: 'Habilidades',
                generatedFrom: 'Gerado de',
                generateSuccess: 'O exercício foi gerado e associado com sucesso',
                generateError: 'Ocorreu um erro ao gerar o exercício',
            },
            parentSkills: 'Categorias de Habilidades',
            'skill-create-error': 'Ocorreu um erro ao criar a categoria',
            'skill-edit-error': 'Ocorreu um erro ao atualizar a categoria',
            'skill-delete-error': 'Ocorreu um erro ao excluir a categoria',
            'skill-created': 'Categoria criada com sucesso',
            'skill-updated': 'Categoria atualizada com sucesso',
        },
        member: {
            dashboard: 'Painel',
            'my-followed-skills': 'Minhas habilidades seguidas',
            'my-progression': 'Minha progressão',
            'my-skills': 'Minhas habilidades',
            documentation: 'Documentação',
            'search-document-input': '🔍 Pesquisar um documento',
            'search-skill-input': '🔍 Pesquisar uma habilidade',
            'satisfaction-survey': 'Pesquisa de Satisfação',
            'satisfaction-survey-iframe-fallback':
                'A pesquisa de satisfação não pode ser exibida. Por favor, clique neste link para acessá-la.',
            'notify-skill-changes': 'Receber notificações por e-mail quando minhas habilidades forem atualizadas',
            'notification-preference-updated': 'Preferência de notificação atualizada com sucesso',
            'welcome-1': 'Oi {{ user.firstname }} {{ user.lastname }},',
            'welcome-2': 'Bem-vindo à sua conta BVA',
            'welcome-4': 'No futuro, novas ferramentas serão adicionadas',
            'edit-password': 'Alterar minha senha',
            'welcome-5':
                'Se você tem qualquer sugestão para melhoria do site nos contacte por email: president@bva-club.fr.',
            'last-news': 'Últimas notícias',
            'change-password-title': 'Mudar senha',
            'current-password-label': 'Senha atual',
            'new-password-label': 'Nova senha',
            'confirm-password-label': 'Confirme nova senha',
        },
        error: {
            'session-expired': 'Sua sessão expirou, você está sendo desconectado por motivos de segurança.',
        },
        page: {
            planning: {
                joyride: {
                    body: {
                        title: 'Horários e Preços',
                        content: 'Um pequeno tour guiado para ajudá-lo a encontrar seu caminho e não perder nada!',
                    },
                    'help-btn': {
                        title: 'Botão Guie-me',
                        content: 'Este botão reinicia o tour guiado.',
                    },
                    'planning-holidays': {
                        title: 'Calendário de Férias Escolares',
                        content: 'Este calendário corresponde às sessões disponíveis durante as férias escolares.',
                    },
                    'planning-summer': {
                        title: 'Calendário de Férias de Verão',
                        content: 'Este calendário corresponde às sessões disponíveis durante as férias de verão.',
                    },
                    legend: {
                        title: 'A Legenda',
                        content: 'Cada calendário contém uma legenda que o ajudará a entender melhor o calendário.',
                    },
                    planning: {
                        title: 'Calendário Principal',
                        content: 'Este calendário corresponde às sessões principais que ocorrerão durante todo o ano.',
                    },
                    try: {
                        title: 'Sessões de julgamento',
                        content: 'Se você for um novato, isso deve lhe interessar!',
                    },
                    'our-prices': {
                        title: 'Nossas licenças',
                        content:
                            'Depois de ter feito pelo menos uma sessão de teste, você pode nos solicitar o formulário de registro. Nesse formulário, você pode escolher a licença que mais lhe convém e o método de pagamento de sua preferência.',
                    },
                },
                'summer-sessions':
                    'As sessões de verão são abertas a todos durante as férias de verão. É um bom momento para vir e experimentar e se divertir conosco nas quadras.',
            },
            contact: {
                title: 'Fale conosco',
            },
            price: {
                title: 'Preços para a temporada {{season}}',
                'title-try': 'Sessões Experimentais',
                'price-try-1':
                    "Você precisa entrar em contato com o clube por e-mail ou telefone, você pode encontrá-los na página <a href='{{contactLink}}'>Contate-nos</a>.",
                'price-try-2': 'Nós podemos emprestar raquetes e petecas para as sessões experimentais.',
                'price-try-3': 'Após isso, você deve trazer sua própria raquete e petecas.',
                'register-info-date':
                    'As inscrições para a renovação dos jogadores já inscritos nesta temporada serão abertas assim que definirmos os horários para a próxima temporada. E no início de setembro, para os novos membros, no início do ano letivo. Uma comunicação será feita e você verá os diferentes preços exibidos aqui.',
                'warning-off-day': '⚠️ Observe: O clube está sempre fechado nos feriados ! ⚠️',
            },
            badnetTournament: {
                title: 'Calendário de Competições',
                upcoming: 'Em breve',
                past: 'Passados',
                'no-data': 'Nenhum torneio disponível no momento.',
                'no-tournaments-day': 'Nenhum torneio neste dia.',
                date: 'Data',
                place: 'Local',
                categories: 'Categorias',
                classifications: 'Classificações',
                deadline: 'Prazo limite',
                participants: 'Participantes',
                register: 'Se inscreva no BadNet',
                helloasso: 'Se inscreva no HelloAsso',
                promoted: 'Promovido',
            },
            login: {
                connexion: 'Login',
                member: 'Membro',
                coach: 'Coach',
                admin: 'Administrador',
                'go-to-member-space': 'Ir para o espaço do membro',
                'go-to-coach-space': 'Ir para o espaço do coach',
                'go-to-admin-space': 'Ir para o espaço do administrador',
                'forgot-password': 'Esqueceu a senha?',
                'reset-password': 'Redefinir senha',
                'connection-success': 'Conectado com sucesso !',
                'send-email': 'Enviar email',
                'pseudo-placeholder': 'Seu nome de usuário',
                'pseudo-received-by-email': 'Nome de usuário * (recebido por email)',
                'enter-email-or-pseudo': 'Digite seu email ou nome de usuário',
                'enter-password': 'Digite sua senha',
                'email-or-pseudo': 'Email ou nome de usuário',
                password: 'Senha',
                connect: 'Entrar',
            },
        },
        joyride: {
            help: 'Me guie !',
            next: 'Próximo',
            last: 'Finalizar Tour',
            skip: 'Fechar',
            back: 'Anterior',
            close: 'Fechar',
        },
        bot: {
            init: 'Oi, como posso te ajudar? Faça uma pergunta curta e use palavras-chave. Por examplo, a palavra "preço" irá te redirecionar para a página com informações sobre valores. Para mensagens longas, nos contacte através do email : contact@bva-club.fr',
        },
        cookies: 'Este site utiliza cookies que dura apenas 24h para medir o número de visitas.',
        skill: { TO_DISCOVER: 'Descobrir', STARTED: 'Iniciado', CONFIRMED: 'Confirmado', MASTERED: 'Masterizado' },
        shop: {
            title: 'Loja',
            products: 'Produtos',
            cart: 'Carrinho',
            checkout: 'Finalizar compra',
            orders: 'Pedidos',
            orderHistory: 'Histórico de pedidos',
            status: 'Status',
            addToCart: 'Adicionar ao carrinho',
            removeFromCart: 'Remover do carrinho',
            quantity: 'Quantidade',
            price: 'Preço',
            stock: 'Estoque',
            outOfStock: 'Fora de estoque',
            lowStock: 'Estoque baixo',
            total: 'Total',
            subtotal: 'Subtotal',
            discount: 'Promoção',
            paymentMethod: 'Método de pagamento',
            paymentMethods: {
                cash: 'Dinheiro',
                transfer: 'Transferência',
                card: 'Cartão',
            },
            uploadProof: 'Carregar comprovante de pagamento',
            uploadHelloAssoProof: 'Carregar comprovante de pagamento HelloAsso',
            proofRequired: 'Comprovante de pagamento necessário',
            orderStatus: {
                pending: 'Pendente',
                validated: 'Validado',
                cancelled: 'Cancelado',
            },
            paymentInstructions: {
                cash: 'Pague em dinheiro ao retirar seu pedido.',
                transfer: 'Faça uma transferência bancária e carregue o comprovante de pagamento.',
                card: 'Pague online via HelloAsso.',
            },
            transferInstructions:
                '⚠️ Importante: Tire uma captura de tela do comprovante de pagamento após concluir a transferência.',
            cashPaymentReminder: 'Lembre-se de levar seu dinheiro no dia da transação.',
            payWithHelloAsso: 'Pagar via HelloAsso',
            helloAssoInstructions:
                'Clique no botão abaixo para pagar cada item via HelloAsso. Você será redirecionado para a plataforma de pagamento segura.',
            noHelloAssoUrl: 'Este produto não tem um link de pagamento HelloAsso configurado.',
            helloAssoScreenshot:
                '⚠️ Importante: Tire uma captura de tela do seu comprovante de pagamento após concluir o pagamento via HelloAsso.',
            qrCode: 'Código QR',
            qrCodeSize: 'Tamanho do código QR',
            scanQRCode: 'Escanear código QR',
            orderConfirmation: 'Confirmação do pedido',
            orderCreated: 'Pedido criado com sucesso',
            productOutOfStock: '{{productName}}: O último item acabou de ser comprado!',
            insufficientStock: '{{productName}}: Estoque insuficiente',
            productRemovedFromCart: '{{productName}} foi removido do seu carrinho pois não está mais em estoque.',
            quantityAdjusted: 'A quantidade de {{productName}} foi ajustada para {{newQuantity}}.',
            productDeactivated: '{{productName}} foi desativado e removido do seu carrinho.',
            orderValidated: 'Pedido validado com sucesso',
            orderCancelled: 'Pedido cancelado com sucesso',
            uploadProofSuccess: 'Comprovante de pagamento carregado com sucesso',
            uploadProofError: 'Erro ao carregar comprovante de pagamento',
            noOrders: 'Nenhum pedido encontrado',
            noProducts: 'Nenhum produto disponível',
            searchProducts: 'Pesquisar produtos',
            filterByCategory: 'Filtrar por categoria',
            allCategories: 'Todas as categorias',
            allStatus: 'Todos os status',
            sortBy: 'Ordenar por',
            sortByName: 'Nome',
            sortByPriceAsc: 'Preço crescente',
            sortByPriceDesc: 'Preço decrescente',
            resultsCount: '{{count}} produto(s) encontrado(s)',
            orderDetails: 'Detalhes do pedido',
            orderItems: 'Itens do pedido',
            paymentProof: 'Comprovante de pagamento',
            viewProof: 'Ver comprovante',
            selectDiscount: 'Selecionar desconto',
            noDiscount: 'Nenhum desconto',
            admin: {
                products: 'Produtos',
                manageProducts: 'Gerenciar produtos',
                manageOrders: 'Gerenciar pedidos',
                searchOrders: 'Pesquisar pedidos',
                scanner: 'Scanner QR',
                scannerLink: 'Scanner de Código QR',
                scanning: 'Buscando pedido...',
                cameraAccessDenied: 'Acesso à câmera negado. Verifique as permissões do seu navegador.',
                cameraPermissionDenied: 'Permissão de câmera negada. Permita o acesso à câmera no seu navegador.',
                cameraNotFound: 'Nenhuma câmera detectada neste dispositivo.',
                stockManagement: 'Gestão de estoque',
                addProduct: 'Adicionar produto',
                editProduct: 'Editar produto',
                deleteProduct: 'Excluir produto',
                validateOrder: 'Validar pedido',
                cancelOrder: 'Cancelar pedido',
                viewProof: 'Ver comprovante de pagamento',
                exportOrders: 'Exportar pedidos',
                exportCSV: 'Exportar CSV',
                helloassoUrl: 'URL HelloAsso',
                image: 'Imagem',
                name: 'Nome',
                description: 'Descrição',
                discounts: 'Descontos',
                category: 'Categoria',
                stockAlert: 'Alerta de estoque',
                lowStockThreshold: 'Limite de estoque baixo',
                stockAlertTitle: 'Alertas de estoque',
                stockAlertDescription: 'Produtos com estoque baixo',
                noLowStockProducts: 'Nenhum produto com estoque baixo',
                viewProduct: 'Ver produto',
                orders: 'Pedidos',
                orderValidated: 'Pedido validado com sucesso',
                orderCancelled: 'Pedido cancelado com sucesso',
                confirmValidate: 'Tem certeza de que deseja validar este pedido?',
                confirmCancel: 'Tem certeza de que deseja cancelar este pedido?',
                noOrdersToExport: 'Nenhum pedido para exportar',
                orderDetails: 'Detalhes do pedido',
                userId: 'ID do Usuário',
                date: 'Data',
                status: 'Status',
                paymentMethod: 'Método de pagamento',
                totalPrice: 'Preço total',
                paymentProof: 'Comprovante de pagamento',
                qrCodeUuid: 'UUID do código QR',
                orderItems: 'Itens do pedido',
                product: 'Produto',
                quantity: 'Quantidade',
                price: 'Preço',
                subtotal: 'Subtotal',
                validationModal: 'Validação do pedido',
                reviewOrder: 'Revisar pedido',
                reviewPaymentProof: 'Revisar comprovante de pagamento',
                noPaymentProof: 'Nenhum comprovante de pagamento fornecido',
                validate: 'Validar',
                cancel: 'Cancelar',
                close: 'Fechar',
                updateStock: 'Atualizar estoque',
                stockUpdated: 'Estoque atualizado com sucesso',
                productCreated: 'Produto criado com sucesso',
                productUpdated: 'Produto atualizado com sucesso',
                productDeleted: 'Produto excluído com sucesso',
                confirmDelete: 'Tem certeza de que deseja excluir este produto?',
                nameRequired: 'Nome é obrigatório',
                descriptionRequired: 'Descrição é obrigatória',
                priceRequired: 'Preço deve ser maior que 0',
                discountNameRequired: 'Nome do desconto é obrigatório',
                discountAmountRequired: 'Valor do desconto deve ser positivo ou zero',
                discountPercentageRange: 'Porcentagem deve estar entre 0 e 100',
                stockRequired: 'Estoque deve ser positivo ou zero',
                invalidUrl: 'URL inválida',
                addDiscount: 'Adicionar desconto',
                removeDiscount: 'Remover',
                discountName: 'Nome do desconto',
                discountAmount: 'Valor',
                discountType: 'Tipo de desconto',
                fixedAmount: 'Valor fixo (€)',
                percentage: 'Porcentagem (%)',
                startDate: 'Data de início',
                sortDateDesc: 'Data decrescente',
                sortDateAsc: 'Data crescente',
                sortPriceDesc: 'Preço decrescente',
                sortPriceAsc: 'Preço crescente',
                sortIdAsc: 'ID crescente',
                sortIdDesc: 'ID decrescente',
            },
        },
    }
}

export default ptTranslation
